import React from 'react';
import { Button } from '../ui/Button';

interface Props {
  title?: string;
  description?: string;
  onRetry?: () => void;
}

const ServiceUnavailable: React.FC<Props> = ({
  title = 'Service Unavailable',
  description = 'We are unable to reach the server to verify your permissions. Please try again in a moment.',
  onRetry,
}) => {
  return (
    <div className="min-h-[50vh] flex flex-col items-center justify-center bg-gray-50 p-6 text-center">
      <div className="max-w-md">
        <div className="text-3xl mb-2">🛠️</div>
        <h2 className="text-xl font-semibold text-gray-900 mb-2">{title}</h2>
        <p className="text-sm text-gray-600 mb-4">{description}</p>
        {onRetry && (
          <Button onClick={onRetry}>
            Retry now
          </Button>
        )}
      </div>
    </div>
  );
};

export default ServiceUnavailable;
